import { defineComponent as p, computed as i } from "vue";
import { DIALOG_VARIANTS as t } from "./dialog-layout-variants.js";
import c from "../sequiter-image/sequiter-image.vue.js";
import { ICONS as u } from "../sequiter-image/icon-library.js";
import { newImageModel as f } from "../sequiter-image/image-model.js";
import { getUniqueId as r } from "../../unique-id/index.js";
import { ScreenSize as S } from "../../user-agent/screensize.js";
const C = p({
  name: "dialog-layout",
  components: { SequiterImage: c },
  props: {
    /**
     * All variants of the dialog
     */
    variant: {
      type: String,
      validator: (e) => Object.values(t).includes(e),
      default: t.ATTENTION
    },
    /**
     * The title of the dialog, this goes in the header
     */
    title: {
      type: String
    },
    /**
     * True if the dialog is currently open and showing. False otherwise. Supports v-model.
     * Must be specified or the dialog will not be able to open or close. Typically you would bind this to
     * a variable of some kind so that you can control if the dialog is open or closed by setting the variable.
     */
    isOpen: {
      type: Boolean,
      required: !0
    },
    /**
     * The icon shown inside the dialog body
     */
    imageBody: {
      type: Object
    },
    /**
     * The icon shown inside the dialog header
     */
    imageHeader: {
      type: Object
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setup(e, { emit: n, slots: I }) {
    const a = r("title"), l = r("description"), s = new S().isSmallOrSmaller, m = i(
      () => [t.ATTENTION, t._HOVER_HELP].includes(e.variant) || !s.value ? "fade" : "slide"
    ), d = i(() => {
      let o = !1;
      return (e.title || e.imageHeader) && (o = !0), o;
    });
    return {
      transitionName: m,
      titleId: a,
      descriptionId: l,
      close() {
        n("update:is-open", !1);
      },
      closeIcon: f(u.X, "Close", "Close"),
      headerHasContent: d
    };
  },
  emits: [
    /**
     * v-model compatible event so that consumers can v-model:isOpen="some boolean value" and closing and opening
     * the dialog will be handled automatically. If you want to handle deciding whether to close or not, you can
     * bind to is-open and @update:is-open separately.
     */
    "update:is-open"
  ]
});
export {
  C as default
};
//# sourceMappingURL=dialog-layout.vue2.js.map
